import { IconButton } from '@components/icon-button';
import { IconDirectionLeft } from '@components/icons/direction-left';
import { IconDirectionRight } from '@components/icons/direction-right';
import { Stack } from '@components/stack';

type ButtonsNextPreviousProps = {
  onNext(): void;
  onPrevious(): void;
};

export const ButtonsNextPrevious = ({ onNext, onPrevious }: ButtonsNextPreviousProps) => (
  <Stack space={2} orientation="horizontal">
    <IconButton icon={<IconDirectionLeft />} onClick={onPrevious} />
    <IconButton icon={<IconDirectionRight />} onClick={onNext} />
  </Stack>
);
